import { useState, useEffect } from 'react';
import axios from 'axios';
import { ArrowUpRight, CalendarDays } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const KalenderPromoCard = ({ getAuthHeader }) => {
  const [promo, setPromo] = useState(null);

  useEffect(() => {
    axios.get(`${API}/promo/kalender`, getAuthHeader())
      .then(res => setPromo(res.data))
      .catch(() => {});
  }, []);

  if (!promo || !promo.active) return null;

  return (
    <div
      className="mb-10 bg-white border border-[#E0D6CA] rounded-sm overflow-hidden shadow-[0_8px_30px_-4px_rgba(82,42,37,0.06)] animate-fade-in-up"
      data-testid="kalender-promo-card"
    >
      <div className="grid sm:grid-cols-[auto_1fr] gap-0">
        <div className="hidden sm:flex items-center justify-center bg-cream-100 p-6">
          <div className="dh-frame -rotate-1 hover:rotate-0 transition-transform duration-500 w-36">
            <div className="dh-mat overflow-hidden">
              <img
                src={promo.image}
                alt={promo.title}
                className="w-full h-44 object-cover object-top"
                data-testid="kalender-promo-image"
              />
            </div>
          </div>
        </div>
        <div className="p-6 sm:p-8 flex flex-col justify-center">
          <div className="flex items-center gap-2 mb-2">
            <CalendarDays className="w-4 h-4 text-terra" strokeWidth={2} />
            <span className="text-[10px] uppercase tracking-[0.28em] font-bold text-terra">
              Neu aus dem Dickies-Campus
            </span>
          </div>
          <h3 className="font-display text-2xl text-espresso tracking-tight">{promo.title}</h3>
          <p className="text-sm italic text-terra mt-0.5">{promo.subtitle}</p>
          <p className="text-sm text-espresso/60 mt-3 max-w-xl">{promo.text}</p>
          <div className="mt-5">
            {promo.link ? (
              <a
                href={promo.link}
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-2 bg-terra text-white text-sm font-semibold px-5 py-2.5 rounded-full hover:bg-terra-dark transition-colors"
                data-testid="kalender-promo-button"
              >
                {promo.button_label} <ArrowUpRight className="w-4 h-4" />
              </a>
            ) : (
              <span
                className="inline-flex items-center gap-2 text-sm font-semibold text-espresso/50 bg-cream-100 px-5 py-2.5 rounded-full"
                data-testid="kalender-promo-soon"
              >
                Bald bei Amazon erhältlich
              </span>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};
